import { render } from "./HelthjemBrand.vue?vue&type=template&id=00aee5ae&scoped=true"
import script from "./HelthjemBrand.vue?vue&type=script&lang=js"
export * from "./HelthjemBrand.vue?vue&type=script&lang=js"

import "./HelthjemBrand.vue?vue&type=style&index=0&id=00aee5ae&scoped=true&lang=scss"

import exportComponent from "/Users/ondrej/dev/www/_showheroes/2023/norway/helthjem-w49/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aee5ae"]])

export default __exports__